import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { injectIntl, defineMessages } from 'react-intl';

import * as common from 'libs/commonFunc';
import { Button, ModalTemplate, Loading } from 'components';
import { Message } from 'semantic-ui-react';

import classNames from 'classnames/bind';
import styles from './ConfigInitial.css';
const cx = classNames.bind(styles);

class ConfigInitial extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isModal, onProgress } = this.props;
    const { onInitialConfig, onToggleModal } = this.props;

    return (
      <div>
        {!!isModal && (
          <ModalTemplate
            closeOnEscape={false}
            closeOnDimmerClick={false}
            className={cx('modal-configInitial-area', 'common-content')}
            visible
            onToggleModal={onToggleModal}
            header={defineMessages(formatMessage({ id: 'ConfigInitial_5', defaultMessage: '설정을 기본값으로 복원' }))}
            buttons={
              <div className={cx('inline-block')}>
                <Button
                  buttonColor="#bbbbbb"
                  onClick={() => {
                    onToggleModal(false);
                  }}>
                  {defineMessages(formatMessage({ id: 'ConfigInitial_3', defaultMessage: '취 소' }))}
                </Button>
                <Button className={cx('brand-button')} disabled={onProgress} onClick={onInitialConfig}>
                  {defineMessages(formatMessage({ id: 'ConfigInitial_2', defaultMessage: '복 원' }))}
                </Button>
              </div>
            }>
            <div className={cx('modal-content')}>
              <Loading active={onProgress} size="small" content="Waiting..." />
              <div className={cx('message-header')}>
                {defineMessages(
                  formatMessage({ id: 'ConfigInitial_4', defaultMessage: '초기 설정의 기본값으로 설정을 복원합니다.' })
                )}
              </div>
            </div>
          </ModalTemplate>
        )}
        <Button
          className={cx('bt-style-gleam common-button-gray')}
          size="small"
          loading={onProgress}
          disabled={onProgress}
          content={defineMessages(formatMessage({ id: 'ConfigInitial_1', defaultMessage: '기본값' }))}
          onClick={() => onToggleModal(true)}
        />
      </div>
    );
  }
}

ConfigInitial.propTypes = {
  paramOptions: PropTypes.object
};
ConfigInitial.defaultProps = {
  paramOptions: {}
};

export default injectIntl(ConfigInitial);



// WEBPACK FOOTER //
// ./src/script/components/config/ConfigInitial.js